module.exports = __webpack_public_path__ + "img/atkins-logo.027a35ef.jpg";